import React from 'react'

export default function Spinner() {
  return (
    <div className='h-screen flex items-center w-min mx-auto justify-center'>
      <div className='spinner'></div>
    </div>
  )
}
